import dynamic from "next/dynamic";
import QueryString from "qs";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { GetServerSideProps, NextPage } from "next";
import BannerJob from "@/Components/pages/ThankYou/bannerJob";
import ThankYouBlogs from "@/Components/pages/ThankYou/ThankYouBlogs";

const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead"),
);

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

interface Props {
  pageData: any;
}
const ThankYou: NextPage<Props> = ({ pageData }) => {
  const blocks = pageData?.blocks;

  const seo = pageData?.seo;

  const router = useRouter();

  useEffect(() => {
    const formData: any = sessionStorage.getItem("form-data");
    // Reload GTM on route change
    window.dataLayer = window.dataLayer || [];
    const eventData = {
      event: "eec.purchase",
      pagePath: router.asPath,
      data: JSON.parse(formData),
    };

    window.dataLayer.push(eventData);

    sessionStorage.removeItem("form-data");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HocHead seo={seo || {}} type="template" />
      <BannerJob block={pageData} />
      {blocks?.map((block: any, i: any) => (
        <div key={i}>
          <ThankYouBlogs block={block} />
        </div>
      ))}

      {/* <div className="middle-sction middle-pad ">
        <div className="thank-you-middle ">
          <section className="thank-you-inner">
            <div className="container mx-auto">
              <div
                className="thank-you-content text-center 
                pt-[80px] pb-[40px] 
                sm:pt-[80px] sm:pb-[50px] 
                md:pt-[120px] md:pb-[60px]"
              >
                <div className="thank-you-img mb-6">
                  <Image
                    src="old/images/thank-you-icon.svg"
                    alt="thank you"
                    width={170}
                    height={170}
                    className="mx-auto xl:w-[170px] xl:h-[170px] w-[150px] h-[150px] md:w-[150px] md:h-[150px]"
                  />
                </div>

                <div className="thank-you-title mb-6">
                  <h1 className="text-[#040405] mb-0 leading-[1.2] block  text-[28px] sm:text-[36px] md:text-[44px] font-[700]">
                    <span
                      className="block text-[24px] sm:text-[28px] md:text-[32px] leading-[34px] sm:leading-[40px] md:leading-[46px]
               bg-gradient-to-br from-[#0086e6] to-[#98f9ffc4] 
               bg-clip-text text-transparent"
                    >
                      Thank You...!
                    </span>
                    <div className="block">{pageData.title}</div>
                  </h1>
                </div>

                <div className="thank-page-content  max-w-[533px] mx-auto">
                  <p className="text-[#616161] opacity-56  pb-6 mb-0 text-base sm:text-lg">
                    Let’s find a moment to chat about your case so that we can
                    understand you better and plan ahead.
                  </p>

                  <Link
                    href="/"
                    className="inline-block font-semibold text-white text-[16px] leading-[22.4px] 
             px-5 py-[18px] rounded-lg 
             bg-gradient-to-r from-[#78c4fb] to-[#0086e6] 
             shadow-md hover:opacity-90 transition"
                  >
                    Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
          <div>
            {block.__component === "blocks.testimonials" && (
              <Testimonial block={block} />
            )}
            {block.__component === "blocks.related-articles" && (
              <ThankYouBlogs block={block} />
            )}
            {block.__component === "blocks.top-case-studies" && (
              <ThankYouTopStories block={block} />
            )}
          </div>
      </div> */}
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  let pageData = {};
  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: "thank-you",
        },
      },
      populate: "deep",
    },
    {
      encodeValuesOnly: false,
    }
  );
  const response = await fetch(
    `${baseUrl}thank-you?${decodeURIComponent(query)}`
  );
  const resData = await response.json();
  if (resData) {
    pageData = resData?.data?.attributes;
  }

  return {
    props: {
      pageData,
    },
  };
};

export default ThankYou;
